import React from "react";
import { Row, Col } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import "./input.scss";

function InputField(props) {
  const { id, label, value, onChange, type, forwardRef, placeholder, validationMsg, layoutStyle, required, labelColSize, inputColSize, multiple, webkitdirectory, name, accept } = props;

  const renderLayout = () => {
    switch (layoutStyle) {
    case "horizontal":
      return (
        <Row>
          <Col md={labelColSize || 5}>
            <Form.Label htmlFor={id}>
              {label} {required && <span className="text-danger">*</span>}
            </Form.Label>
          </Col>
          <Col md={inputColSize || 7}>
            <Form.Control
              type={type || "input"}
              id={id}
              placeholder={placeholder}
              className={"input-field"}
              name={name}
              value={value}
              multiple={multiple}
              onChange={onChange}
              ref={forwardRef}
              webkitdirectory={webkitdirectory}
              accept={accept}
            />
            {validationMsg && <div className="text-danger validation-msg">{validationMsg}</div>}
          </Col>
        </Row>
      );
    case "chat-input":
      return (
        <Row>
          <Col>
            <Form.Control
              type={type || "input"}
              id={id}
              placeholder={placeholder}
              className={"input-field"}
              name={name}
              value={value}
              multiple={multiple}
              onChange={onChange}
              ref={forwardRef}
              webkitdirectory={webkitdirectory}
              accept={accept}
            />
            {validationMsg && <div className="text-danger validation-msg">{validationMsg}</div>}
          </Col>
        </Row>
      );
    case "vertical":
    default:
      return (
        <div>
          <Form.Label htmlFor={id}>
            {label} {required && <span className="text-danger">*</span>}
          </Form.Label>
          <Form.Control
            type={type || "input"}
            id={id}
            placeholder={placeholder}
            className={"input-field"}
            name={name}
            value={value}
            onChange={onChange}
            ref={forwardRef}
            webkitdirectory={webkitdirectory}
            accept={accept}
            multiple={multiple}
          />
          {validationMsg && <div className="text-danger validation-msg">{validationMsg}</div>}
        </div>
      );
    }
  };

  return renderLayout();
}

export default InputField;
  